import { render, staticRenderFns } from "./oneItem.vue?vue&type=template&id=143689ba&scoped=true&"
import script from "./oneItem.vue?vue&type=script&lang=js&"
export * from "./oneItem.vue?vue&type=script&lang=js&"
import style0 from "./oneItem.vue?vue&type=style&index=0&id=143689ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143689ba",
  null
  
)

export default component.exports